import { useState, type FormEvent } from "react";

const submitAddr = "https://readdy.ai/api/form/db96089rh5tg6sock3tg";

export default function ContactForm() {
  const [status, setStatus] = useState<"idle" | "submitting" | "success" | "error">("idle");
  const [error, setError] = useState("");

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    const honeypot = String(formData.get("contact_alt") ?? "").trim();
    if (honeypot) {
      setStatus("success");
      form.reset();
      return;
    }
    formData.delete("contact_alt");

    setStatus("submitting");
    setError("");

    try {
      const response = await fetch(submitAddr, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      const isSpam = typeof serverMsg === "string" && serverMsg.toLowerCase().includes("spam");

      if (response.ok && parsed?.code === "OK" && !isSpam) {
        setStatus("success");
        form.reset();
      } else {
        setStatus("error");
        setError(serverMsg || "提交失败，请稍后重试。");
      }
    } catch {
      setStatus("error");
      setError("网络异常，请稍后重试。");
    }
  };

  return (
    <form data-readdy-form onSubmit={handleSubmit} className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-7">
      <input
        type="text"
        name="contact_alt"
        className="contact-alt-field"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
      />
      <h3 className="font-heading text-xl font-bold text-foreground-950">给 97影院留言</h3>
      <p className="mt-1.5 text-sm text-foreground-500">本表单仅用于演示与意见收集，我们会认真阅读每一条建议。</p>

      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div>
          <label htmlFor="about-name" className="mb-1.5 block text-sm font-medium text-foreground-700">称呼</label>
          <input
            id="about-name"
            name="name"
            type="text"
            required
            placeholder="请输入你的称呼"
            className="h-11 w-full rounded-md border border-background-300 bg-background-100 px-3 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-100"
          />
        </div>
        <div>
          <label htmlFor="about-email" className="mb-1.5 block text-sm font-medium text-foreground-700">邮箱</label>
          <input
            id="about-email"
            name="email"
            type="email"
            required
            placeholder="用于接收回复的邮箱"
            className="h-11 w-full rounded-md border border-background-300 bg-background-100 px-3 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-100"
          />
        </div>
      </div>

      <div className="mt-4">
        <label htmlFor="about-subject" className="mb-1.5 block text-sm font-medium text-foreground-700">主题</label>
        <input
          id="about-subject"
          name="subject"
          type="text"
          placeholder="如：内容纠错 / 合作建议"
          className="h-11 w-full rounded-md border border-background-300 bg-background-100 px-3 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-100"
        />
      </div>

      <div className="mt-4">
        <label htmlFor="about-message" className="mb-1.5 block text-sm font-medium text-foreground-700">留言内容</label>
        <textarea
          id="about-message"
          name="message"
          required
          maxLength={500}
          rows={4}
          placeholder="请输入你的建议或问题（最多 500 字）"
          className="w-full resize-none rounded-md border border-background-300 bg-background-100 px-3 py-2.5 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-100"
        />
      </div>

      {status === "error" && (
        <p className="mt-4 flex items-center gap-1.5 rounded-md bg-accent-50 px-3 py-2 text-sm text-accent-800">
          <i className="ri-error-warning-line" />
          {error}
        </p>
      )}
      {status === "success" && (
        <p className="mt-4 flex items-center gap-1.5 rounded-md bg-secondary-100 px-3 py-2 text-sm text-secondary-900">
          <i className="ri-checkbox-circle-line" />
          提交成功，感谢你的留言！我们会尽快查看。
        </p>
      )}

      <button
        type="submit"
        disabled={status === "submitting"}
        className="mt-6 flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 disabled:opacity-60"
      >
        <i className="ri-send-plane-line text-base" />
        {status === "submitting" ? "提交中…" : "提交留言"}
      </button>
    </form>
  );
}